<template>
  <WdsMenu manual-trigger placement="bottom-end" :global="tableGlobals" z-index="2">
    <template #trigger="{ toggle }">
      <WdsButtonIcon sm transparent-background data-test="supplier-link-actions" @click="toggle">
        <WdsIcon :name="WdsIconNameEnum.OVERFLOW_MENU_HORIZONTAL" :size="18" />
      </WdsButtonIcon>
    </template>

    <template v-if="isAgency">
      <WdsMenuOption data-test="supplier-link-placements" @click="openPlacements">
        <WdsIcon :name="WdsIconNameEnum.LAUNCH" :size="16" />
        {{ $t('View placements') }}
      </WdsMenuOption>

      <WdsMenuDivider />
    </template>

    <WdsMenuOption theme="DESTRUCTIVE" data-test="supplier-link-unlink" @click="requestUnlink">
      <WdsIcon :name="WdsIconNameEnum.CLOSE_OUTLINE" :size="16" />
      {{ $t('Unlink from this client') }}
    </WdsMenuOption>
  </WdsMenu>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  WdsButtonIcon,
  WdsIcon,
  WdsIconNameEnum,
  WdsMenu,
  WdsMenuDivider,
  WdsMenuOption,
} from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { sharedPlacementsUrl } from '@/components/Clients/placementFilters'
import type { PendingSupplierUnlink } from '@/components/Clients/supplierLinkUnlink'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const RecruiterLinkActions = graphql(`
  fragment RecruiterLinkActions on SupplierClient {
    id
    client {
      id
      name
    }
    supplier {
      __typename
      id
      name
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof RecruiterLinkActions>
}>()

const emit = defineEmits<{ (e: 'unlink', link: PendingSupplierUnlink): void }>()

const link = computed(() => useFragment(RecruiterLinkActions, props.row))
// The placements page filters agencies by Recruiter id; a company supplier has no such filter.
const isAgency = computed(() => link.value.supplier.__typename === 'Recruiter')

function openPlacements() {
  window.location.href = sharedPlacementsUrl(link.value.client, link.value.supplier)
}

// The table owns the confirmation, so it lives beside the table's other overlays.
function requestUnlink() {
  emit('unlink', { linkId: link.value.id, supplierName: link.value.supplier.name })
}
</script>
